export const MICROLEARNING_TITLE_ID = 'microlearning-title'
export const MICROLEARNING_LABEL = 'microlearning-label'
